module.exports = __webpack_public_path__ + "img/8-2.3b5498e1.jpg";